import { render } from "./BaseStoneButton.vue?vue&type=template&id=e5ea2c5a"
import script from "./BaseStoneButton.vue?vue&type=script&lang=js"
export * from "./BaseStoneButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__